export const infoElements = [
  {
    name: "name",
    label: "Name",
    type: "text",
    required: true,
    placeholder: "Enter transporter name",
  },
  {
    name: "phoneNumber",
    label: "Phone",
    type: "tel",
    required: true,
    placeholder: "Enter transporter phone number",
  },
  {
    name: "email",
    label: "Email",
    type: "email",
    required: true,
    placeholder: "Enter transporter email",
  },
  {
    name: "password",
    label: "Password",
    type: "password",
    required: true,
    placeholder: "Enter password",
  },
  {
    name: "companyName",
    label: "Company Name",
    type: "text",
    required: true,
    placeholder: "Enter company name",
  },
  {
    name: "companyPhoneNumber",
    label: "Company phone number",
    type: "text",
    placeholder: "Enter company phone number",
  },
  {
    name: "companyEmail",
    label: "Company Email",
    type: "email",
    placeholder: "Enter company email",
  },
];
